// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from 'C:/Users/kyyyy/desktop/lounge-admin-client/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import UserOutlined from 'C:/Users/kyyyy/desktop/lounge-admin-client/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { DashboardOutlined, UserOutlined };
